module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('el-row', {
    staticClass: "stickyContent",
    staticStyle: {
      "top": "0px"
    }
  }, [_c('div', {
    staticClass: "titles"
  }, [_c('span', {
    staticClass: "fonts"
  }, [_vm._v("教学进程表（学年制）")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "size": "mini",
      "disabled": _vm.editDisableState
    },
    on: {
      "click": function($event) {
        return _vm.addCAP()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini",
      "disabled": _vm.editDisableState
    },
    on: {
      "click": function($event) {
        return _vm.popGrid()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-minus"
  })])], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', [_c('p', [_vm._v("课程名称下拉框的数据来自系统内已设置的课程。")]), _vm._v(" "), _c('p', [_vm._v("\n                课程分为公共课程和专业课程。"), _c('br'), _vm._v("\n                公共课程的课程代码由6位固定代码100000+4位序号构成"), _c('br'), _vm._v("专业课程的课程代码由6位国标专业编号+1位模式代码+2位序号+1位学期号构成\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                总学时验证规则：总学时-各学期周学时*周数之和。若等于则通过，否则给予相应提示。\n            ")])])]), _vm._v(" "), _c('el-row', {
    staticClass: "courseContent"
  }, [_c('el-table', {
    ref: "CAPTable",
    staticClass: "tb-edit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.CAPS,
      "header-cell-style": {
        'text-align': 'center',
        'blackground-color': '#f1faf6'
      },
      "element-loading-text": "信息加载中",
      "stripe": "",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": _vm.capTableHeight,
      "row-style": {
        'height': '64px'
      }
    },
    on: {
      "selection-change": _vm.handleCoursesSelection,
      "row-click": function (row, column, event) { return _vm.handleRowClick('CAPTable', row, column, event); }
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "65",
      "align": "center",
      "prop": "xh",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [_c('el-input', {
          staticStyle: {
            "width": "45px"
          },
          attrs: {
            "controls": false,
            "size": "mini",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChangeXH(scope)
            }
          },
          model: {
            value: (scope.row.xh),
            callback: function($$v) {
              _vm.$set(scope.row, "xh", $$v)
            },
            expression: "scope.row.xh"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatterNumShow(scope.row.xh)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程类别",
      "prop": "courseKind",
      "width": "160",
      "align": "center",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "visible-change": function($event) {
              return _vm.handleCourseTypeOptionVisible(scope)
            },
            "change": function($event) {
              return _vm.handleCourseTypeChange(scope)
            }
          },
          model: {
            value: (scope.row.courseKind),
            callback: function($$v) {
              _vm.$set(scope.row, "courseKind", $$v)
            },
            expression: "scope.row.courseKind"
          }
        }, _vm._l((_vm.kinds), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.courseTypeName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程性质",
      "prop": "courseProperties",
      "width": "160",
      "align": "center",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [_c('el-select', {
          attrs: {
            "placeholder": scope.row.kcsxholder,
            "disabled": scope.row.kcsxDisabled
          },
          on: {
            "visible-change": function($event) {
              return _vm.handleCoursePropertiesOptionVisible(scope)
            }
          },
          model: {
            value: (scope.row.courseProperties),
            callback: function($$v) {
              _vm.$set(scope.row, "courseProperties", $$v)
            },
            expression: "scope.row.courseProperties"
          }
        }, _vm._l((_vm.kcsxInfo), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.comboName,
              "value": item.comboValue
            }
          })
        }), 1)], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.coursePropertiesName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程名称",
      "min-width": "220",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [_c('el-select', {
          attrs: {
            "filter-method": _vm.searchFilterCourse,
            "filterable": ""
          },
          on: {
            "focus": function($event) {
              return _vm.handleCourseFocus(scope)
            },
            "visible-change": function($event) {
              return _vm.handleCourseOptionVisible(scope)
            },
            "change": function($event) {
              return _vm.handleCourseChange(scope)
            }
          },
          model: {
            value: (scope.row.fullName),
            callback: function($$v) {
              _vm.$set(scope.row, "fullName", $$v)
            },
            expression: "scope.row.fullName"
          }
        }, [_vm._l((_vm.filterOptionCourses), function(item, index) {
          return _c('el-option', {
            key: item.label + index,
            attrs: {
              "label": item.label,
              "value": item.value,
              "disabled": item.disabled
            }
          })
        }), _vm._v(" "), (_vm.filterOptionCourses.length === 10 && _vm.tempOptionCourses.length > 10 ||
          _vm.filterOptionCourses.length === 11 && _vm.tempOptionCourses.length > 11) ? _c('el-option', {
          attrs: {
            "value": "tip",
            "disabled": ""
          }
        }, [_c('span', {
          staticClass: "gray"
        }, [_vm._v("--只展示前10条数据，更多数据请输入详细查询条件--")])]) : _vm._e()], 2)], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.courseName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程类型",
      "width": "80",
      "align": "center",
      "prop": "courseCategoryName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [_vm._v(_vm._s(scope.row.courseCategoryName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.courseCategoryName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学分",
      "width": "90",
      "align": "center",
      "prop": "score"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumShow(scope.row.score)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总学时",
      "width": "90",
      "align": "center",
      "prop": "totalTime"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumShow(scope.row.totalTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "理论教学",
      "width": "90",
      "prop": "theoryTime",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumShow(scope.row.theoryTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实验实训",
      "width": "90",
      "prop": "practiseTime",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumShow(scope.row.practiseTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '是否专业\n核心课程',
      "width": "90",
      "prop": "isMajorcore",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": function($event) {
              return _vm.handleMajorcoreChange(scope)
            }
          },
          model: {
            value: (scope.row.isMajorcore),
            callback: function($$v) {
              _vm.$set(scope.row, "isMajorcore", $$v)
            },
            expression: "scope.row.isMajorcore"
          }
        }, _vm._l((_vm.sfzt), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.comboName,
              "value": item.comboValue
            }
          })
        }), 1)], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.isMajorcoreName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '是否考证\n课程',
      "width": "90",
      "prop": "isCertificate",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": function($event) {
              return _vm.handleCertificateChange(scope)
            }
          },
          model: {
            value: (scope.row.isCertificate),
            callback: function($$v) {
              _vm.$set(scope.row, "isCertificate", $$v)
            },
            expression: "scope.row.isCertificate"
          }
        }, _vm._l((_vm.sfzt), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.comboName,
              "value": item.comboValue
            }
          })
        }), 1)], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.isCertificateName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "考核方式",
      "width": "110",
      "prop": "examType",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": function($event) {
              return _vm.handleExamTypeChange(scope)
            }
          },
          model: {
            value: (scope.row.examType),
            callback: function($$v) {
              _vm.$set(scope.row, "examType", $$v)
            },
            expression: "scope.row.examType"
          }
        }, _vm._l((_vm.examType), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.comboName,
              "value": item.comboValue
            }
          })
        }), 1)], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.examTypeName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "各学期周数、学时分配",
      "align": "center"
    }
  }, [(_vm.xz * 2 >= 1) ? _c('el-table-column', {
    attrs: {
      "label": "一"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.first,
      "prop": "term1",
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [(_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.term1),
            callback: function($$v) {
              _vm.$set(scope.row, "term1", $$v)
            },
            expression: "scope.row.term1"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2) : _vm._e(), _vm._v(" "), (_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.week1),
            callback: function($$v) {
              _vm.$set(scope.row, "week1", $$v)
            },
            expression: "scope.row.week1"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term1, scope.row.week1)))])]
      }
    }], null, false, 2838323278)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.xz * 2 >= 2) ? _c('el-table-column', {
    attrs: {
      "label": "二"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.second,
      "prop": "term2",
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [(_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.term2),
            callback: function($$v) {
              _vm.$set(scope.row, "term2", $$v)
            },
            expression: "scope.row.term2"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2) : _vm._e(), _vm._v(" "), (_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.week2),
            callback: function($$v) {
              _vm.$set(scope.row, "week2", $$v)
            },
            expression: "scope.row.week2"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term2, scope.row.week2)))])]
      }
    }], null, false, 3843549998)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.xz * 2 >= 3) ? _c('el-table-column', {
    attrs: {
      "label": "三"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.third,
      "prop": "term3",
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [(_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.term3),
            callback: function($$v) {
              _vm.$set(scope.row, "term3", $$v)
            },
            expression: "scope.row.term3"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2) : _vm._e(), _vm._v(" "), (_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.week3),
            callback: function($$v) {
              _vm.$set(scope.row, "week3", $$v)
            },
            expression: "scope.row.week3"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term3, scope.row.week3)))])]
      }
    }], null, false, 2116167822)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.xz * 2 >= 4) ? _c('el-table-column', {
    attrs: {
      "label": "四"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.fourth,
      "prop": "term4",
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [(_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.term4),
            callback: function($$v) {
              _vm.$set(scope.row, "term4", $$v)
            },
            expression: "scope.row.term4"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2) : _vm._e(), _vm._v(" "), (_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.week4),
            callback: function($$v) {
              _vm.$set(scope.row, "week4", $$v)
            },
            expression: "scope.row.week4"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term4, scope.row.week4)))])]
      }
    }], null, false, 2814686830)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.xz * 2 >= 5) ? _c('el-table-column', {
    attrs: {
      "label": "五"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.fifth,
      "prop": "term5",
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [(_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.term5),
            callback: function($$v) {
              _vm.$set(scope.row, "term5", $$v)
            },
            expression: "scope.row.term5"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2) : _vm._e(), _vm._v(" "), (_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.week5),
            callback: function($$v) {
              _vm.$set(scope.row, "week5", $$v)
            },
            expression: "scope.row.week5"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term5, scope.row.week5)))])]
      }
    }], null, false, 3660782798)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.xz * 2 >= 6) ? _c('el-table-column', {
    attrs: {
      "label": "六"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.sixth,
      "prop": "term6",
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [(_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.term6),
            callback: function($$v) {
              _vm.$set(scope.row, "term6", $$v)
            },
            expression: "scope.row.term6"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2) : _vm._e(), _vm._v(" "), (_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.week6),
            callback: function($$v) {
              _vm.$set(scope.row, "week6", $$v)
            },
            expression: "scope.row.week6"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term6, scope.row.week6)))])]
      }
    }], null, false, 376961454)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.xz * 2 >= 7) ? _c('el-table-column', {
    attrs: {
      "label": "七"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.seventh,
      "prop": "term7",
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [(_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.term7),
            callback: function($$v) {
              _vm.$set(scope.row, "term7", $$v)
            },
            expression: "scope.row.term7"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2) : _vm._e(), _vm._v(" "), (_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.week7),
            callback: function($$v) {
              _vm.$set(scope.row, "week7", $$v)
            },
            expression: "scope.row.week7"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term7, scope.row.week7)))])]
      }
    }], null, false, 1388046606)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.xz * 2 >= 8) ? _c('el-table-column', {
    attrs: {
      "label": "八"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.eighth,
      "prop": "term8",
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [(_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.term8),
            callback: function($$v) {
              _vm.$set(scope.row, "term8", $$v)
            },
            expression: "scope.row.term8"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2) : _vm._e(), _vm._v(" "), (_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.week8),
            callback: function($$v) {
              _vm.$set(scope.row, "week8", $$v)
            },
            expression: "scope.row.week8"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term8, scope.row.week8)))])]
      }
    }], null, false, 1985127662)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.xz * 2 >= 9) ? _c('el-table-column', {
    attrs: {
      "label": "九"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.ninth,
      "prop": "term9",
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [(_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.term9),
            callback: function($$v) {
              _vm.$set(scope.row, "term9", $$v)
            },
            expression: "scope.row.term9"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2) : _vm._e(), _vm._v(" "), (_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.week9),
            callback: function($$v) {
              _vm.$set(scope.row, "week9", $$v)
            },
            expression: "scope.row.week9"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term9, scope.row.week9)))])]
      }
    }], null, false, 2627799886)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.xz * 2 >= 10) ? _c('el-table-column', {
    attrs: {
      "label": "十"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.weeks.tenth,
      "prop": "term10",
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [(_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.term10),
            callback: function($$v) {
              _vm.$set(scope.row, "term10", $$v)
            },
            expression: "scope.row.term10"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2) : _vm._e(), _vm._v(" "), (_vm.renderFlag) ? _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          on: {
            "change": function($event) {
              return _vm.handleChange(scope)
            }
          },
          model: {
            value: (scope.row.week10),
            callback: function($$v) {
              _vm.$set(scope.row, "week10", $$v)
            },
            expression: "scope.row.week10"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.term10, scope.row.week10)))])]
      }
    }], null, false, 3030694414)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "width": "120",
      "prop": "bz",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "el-edit"
        }, [_c('el-input', {
          attrs: {
            "placeholder": ""
          },
          model: {
            value: (scope.row.bz),
            callback: function($$v) {
              _vm.$set(scope.row, "bz", $$v)
            },
            expression: "scope.row.bz"
          }
        })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.bz))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "关联课程",
      "align": "center",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.relatedCourseConfig(scope.row)
            }
          }
        }, [_vm._v("设置")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.dialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "关联课程设置",
      "visible": _vm.dialogVisible,
      "width": "1000px",
      "top": "150px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "550px"
    }
  }, [_c('relatedCourseConfig', {
    ref: "relatedCourseConfig",
    attrs: {
      "teachingSchemeCode": _vm.teachingSchemeCode,
      "courseCode": _vm.courseCode,
      "listHeight": 450
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35898f71"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/teachingManage/teachingScheme/CourseAndProgress.vue
// module id = 1807
// module chunks = 502